import { render, staticRenderFns } from "./doc_general.vue?vue&type=template&id=690ac3d0&scoped=true&"
import script from "./doc_general.vue?vue&type=script&lang=js&"
export * from "./doc_general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690ac3d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690ac3d0')) {
      api.createRecord('690ac3d0', component.options)
    } else {
      api.reload('690ac3d0', component.options)
    }
    module.hot.accept("./doc_general.vue?vue&type=template&id=690ac3d0&scoped=true&", function () {
      api.rerender('690ac3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_enginer/doc/edit/tabs/doc_general.vue"
export default component.exports